<template>
  <div :class="{ mobile: device === 'mobile' }">
    <div class="unit-container">
      <span class="heading">{{ $t('cylinder.calculator.displayUnit') }}</span>
      <form class="radio-container">
        <input type="radio" :value="1" v-model="forceUnit" name="force" id="radio-1">
        <label for="radio-1">kg</label>
        <input type="radio" :value="2" v-model="forceUnit" name="force" id="radio-2">
        <label for="radio-2">kN</label>
      </form>
    </div>

    <div class="menu-container">
      <menu-item :label="$t('cylinder.calculator.circuit')" tooltip-key="tooltip_cilinder_hydraulic_circuit">
        <form class="radio-container">
          <input type="radio" :value="1" v-model="circuit" name="circuit" id="radio-3">
          <label for="radio-3">{{ $t('cylinder.calculator.double') }}</label>
          <input type="radio" :value="2" v-model="circuit" name="circuit" id="radio-4">
          <label for="radio-4">{{ $t('cylinder.calculator.single') }}</label>
        </form>
      </menu-item>

      <menu-item-number
          tooltip-key="tooltip_cilinder_pressure"
          :label="$t('cylinder.calculator.pressure')"
          :val="cilinder.pressure"
          :link="true"
          @change="setPressure"
          type="workPressure"
          :tab="1"
          unit="Bar">
      </menu-item-number>

      <menu-item-number
          tooltip-key="tooltip_cilinder_oilflow"
          :label="$t('cylinder.calculator.oilFlow')"
          :val="cilinder.oilFlow"
          :link="true"
          @change="setOilFlow"
          type="speed"
          :tab="1"
          :unit="$t('cylinder.calculator.lpm')">
      </menu-item-number>

      <menu-item-number
          tooltip-key="tooltip_cilinder_piston"
          :label="$t('cylinder.calculator.pistonDiameter')"
          :val="cilinder.pistonDiameter"
          :link="true"
          @change="setPistonDiameter"
          type="pressure"
          subtype="piston"
          :tab="1"
          unit="mm">
      </menu-item-number>

      <menu-item-number
          tooltip-key="tooltip_cilinder_rod"
          :label="$t('cylinder.calculator.rodDiameter')"
          :val="cilinder.rodDiameter"
          :link="true"
          @change="setRodDiameter"
          type="pressure"
          subtype="rod"
          :tab="2"
          unit="mm">
      </menu-item-number>

      <menu-item-number
          tooltip-key="tooltip_cilinder_stroke"
          :label="$t('cylinder.calculator.stroke')"
          :val="cilinder.stroke"
          @change="setStroke"
          unit="mm">
      </menu-item-number>

      <menu-item
          :label="$t('cylinder.calculator.attachment')"
          tooltip-key="tooltip_cilinder_attachment">
        <input-dropdown :options="typesFiltered" @change="setType" :value="cilinder.type"></input-dropdown>
      </menu-item>

    </div>
  </div>
</template>

<script>
import MenuItem from "../step2/menu/MenuItem";
import MenuItemNumber from "../step2/menu/MenuItemNumber";
import InputDropdown from "../input/Dropdown";
import Label from "../input/Label";
import Dropdown from "../input/Dropdown";

import {mapState, mapGetters} from 'vuex';
import CoddinButton from "@/components/input/Button.vue";
import { getFromStorage } from "@/helpers/backendStorage";

export default {
  name: "Calculator",

  components: {
    CoddinButton,
    Label,
    MenuItem,
    InputDropdown,
    MenuItemNumber,
    Dropdown
  },

  data() {
    return {
      pistonDiameter: 0,
      rodDiameter: 0,
      stroke: 0,
      pressure: 0,
      oilflow: 0,
      al: 0,
      s: 0,
      k: 0,
      types: [
          {key: 1, value: 'Zonder bevestiging', recommended: 0},
          {key: 2, value: 'Gelenkoog', recommended: 0},
          {key: 3, value: 'Standaard bevestiging', recommended: 0},
          {key: 4, value: 'Frontflens', recommended: 0},
          {key: 5, value: 'Gaffel', recommended: 0},
          {key: 6, value: 'Topstangoog', recommended: 0},
          {key: 7, value: 'Brede bevestiging', recommended: 0},
      ]
    }
  },

  computed: {
    ...mapState({
      selectedCilinder: state => state.preference.selectedCilinder
    }),
    ...mapGetters({
      cilinder: 'preference/getCilinderOptions',
      cilinders: 'cilinders/byId',
      device: 'getDevice'
    }),
    typesFiltered(){
      let imageName = this.circuit === 1 ? "image_double" : "image_single"
      let array = this.$store.state.cilinders.attachments.filter((attachments) => {
        return getFromStorage(attachments[imageName]);
      });

      array = array.map((a) => {
        return {key: a.id, value: this.translate(a.name)}
      }) || this.types;

      array.unshift({key: 0, value: this.$t('cylinder.calculator.allAttachments')});

      return array;
    },

    circuit: {
      get() {
        return this.cilinder.circuit;
      },
      set(val) {
        this.$store.commit('preference/setCilinderCircuit', val)
        this.$store.dispatch('preference/resetCilinderType')
      }
    },
    forceUnit: {
      get() {
        return this.cilinder.forceUnit;
      },
      set(val) {
        this.$store.commit('preference/setCilinderForce', val)
      }
    },
  },
  watch: {
    selectedCilinder: function(val){
      if(val){
        let {stroke_k, piston_al, rod_s} = this.cilinders[val];
        this.pistonDiameter = piston_al;
        this.rodDiameter = rod_s;
        this.stroke = stroke_k;
      }
    }
  },
  methods: {
    onInputChange() {
      this.$store.commit('preference/resetCilinderSelection');
    },
    setType(val) {
      this.onInputChange();
      this.$store.dispatch('preference/setCilinderType', val);
    },
    setPressure(val) {
      this.$store.commit('preference/setCilinderPressure', val)
    },
    setOilFlow(val) {
      this.$store.commit('preference/setCilinderOilFlow', val)
    },
    setPistonDiameter(val) {
      this.$store.dispatch('preference/setCilinderPistonDiameter', val)
    },
    setRodDiameter(val) {
      this.$store.dispatch('preference/setCilinderRodDiameter', val)
    },
    setStroke(val) {
      this.$store.dispatch('preference/setCilinderStroke', val)
    }
  },
}

</script>


<style scoped lang="scss">

.mobile {
  .unit-container {
    padding: 17px 14px 20px 17px;
  }
  .menu-container {
    width: 100%;
    max-width: none;
    margin-top: 0;
  }
}

.radio-container {
  border-radius: 50px;
  border: 2px solid #EBEBEB;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background-color: white;
  margin-bottom: 10px;
  transition: all ease 0.3s;

  label {
    cursor: pointer;
    display: flex;
    justify-content: center;
    font-size: 12px;
    margin: 0;
    border-radius: 25px;
    width: 50%;
    padding: 9px;
    user-select: none;
    font-family: neue-haas-grotesk-display, sans-serif;
  }

  input[type="radio"] {
    display: none;


    &:checked + label {
      background-color: #3DB0C7;
      color: white;
    }
  }
}

.menu-container {
  max-width: 270px;
  min-width: 270px;
  margin-top: 20px;
  background-color: #FAFAFA;
  /* box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.16); */
  border-right: 3px solid #F0F0F0;
  border-bottom: 3px solid #F0F0F0;
  padding: 17px 14px 20px 17px;
}

  .heading {
    font-family: neue-haas-grotesk-display, sans-serif;
    font-weight: 700;
    font-size: 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 6px;
}

.image-header {
  height: 50px;
  background-color: lighten(gray, 40%);
  border-bottom: 1px solid gray;
}

.inputs {
  border-top: 1px solid gray;
  background-color: white;

  ul {
    list-style: none;
    margin: 0;
    padding: 12px 0 12px 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid gray;

    li {
      &:first-child {
        width: 220px;
      }

      &:last-child {
        margin-left: 12px;
      }

      label {
        margin: 0;
      }
    }
  }
}

.calculate {
  padding: 10px 0 10px 15px;
  margin-bottom: 20px;
  background-color: white;

  table {

    tr {
      input {
        max-width: 90%;
      }

      td {
        padding: 5px;
      }
    }
  }
}
</style>
